export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface NotificationConfig {
  message?: string;
  description?: string;
  duration?: number;
  placement?: string;
  onClose?: () => void;
}

export interface NotificationHandler {
  open: (type: NotificationType, config: NotificationConfig) => void;
}

let handler: NotificationHandler | null = null;

export function setNotificationHandler(h: NotificationHandler | null) {
  handler = h;
}

function open(type: NotificationType, config: NotificationConfig) {
  if (handler) {
    handler.open(type, config);
  } else if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(`[ui/notification] ${type}:`, config.message, config.description);
  }
}

function makeMethod(type: NotificationType) {
  return (config: NotificationConfig) => open(type, config);
}

export const notification = {
  success: makeMethod('success'),
  error: makeMethod('error'),
  warning: makeMethod('warning'),
  info: makeMethod('info'),
  open: (config: NotificationConfig & { type?: NotificationType }) => {
    open(config.type || 'info', config);
  },
};

export default notification;
